import React, { useEffect } from 'react';
import { Button, Col, Form, Input, Modal, notification, Row } from 'antd';
import { useMutation } from '@tanstack/react-query';
import { IDataModal } from '@/interfaces/dataModal';
import { IUser, IUserResetPassword } from '@/interfaces/user';
import { resetPassword } from '@/adapters/user';

interface IProps {
  dataModal?: IDataModal<Partial<IUser>>;
  handleOk: () => void;
  handleCancel: () => void;
}

const UserResetPasswordModal = ({
  dataModal,
  handleOk,
  handleCancel,
}: IProps) => {
  const [form] = Form.useForm<IUserResetPassword>();
  const mutations = useMutation({
    mutationFn: async (data: IUserResetPassword) => await resetPassword(data),
    mutationKey: ['reset-password'],
    onSuccess: data => {
      if (data?.status != 200) {
        throw new Error();
      } else {
        const message = 'เปลี่ยนรหัสผ่านสำเร็จ';
        notification.success({
          message: message,
        });
        handleOk();
      }
    },
    onError: error => {
      console.log(error);
    },
  });

  const handleUpdate = async () => {
    form
      .validateFields()
      .then(async (values: IUserResetPassword) => {
        await mutations.mutateAsync(values);
      })
      .catch(info => {
        console.log('Validate Failed:', info);
      });
  };

  const onReset = () => {
    form.resetFields();
  };

  useEffect(() => {
    if (dataModal?.item) {
      form.setFieldsValue({
        ...dataModal.item,
      });
    }
  }, [dataModal?.item]);

  return (
    <Modal
      title={'เปลี่ยนรหัสผ่าน'}
      open={dataModal?.open}
      onOk={() => handleUpdate()}
      onCancel={handleCancel}
      okText="บันทึก"
      cancelText="ยกเลิก"
      width={600}
      footer={[
        <Button key="back" onClick={handleCancel}>
          ยกเลิก
        </Button>,
        <Button
          key="submit"
          type="primary"
          form="productGroup"
          loading={mutations.isPending}
          onClick={handleUpdate}
        >
          บันทึก
        </Button>,
      ]}
      afterClose={onReset}
    >
      <div className="flex w-full">
        <Form
          form={form}
          name="productGroup"
          onFinish={handleUpdate}
          layout="vertical"
          className="w-full"
        >
          <Row gutter={12}>
            <Col span={24}>
              <Form.Item
                label="USERNAME"
                name="userName"
                rules={[{ required: true, message: 'ระบุ USERNAME' }]}
              >
                <Input
                  size="large"
                  autoComplete="nope"
                  readOnly={!!dataModal?.item}
                />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                label="รหัสผ่าน"
                name="password"
                rules={[{ required: true, message: 'ระบุ รหัสผ่าน' }]}
              >
                <Input size="large" autoComplete="nope" />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </div>
    </Modal>
  );
};

export default UserResetPasswordModal;
